module.exports = __webpack_public_path__ + "media/colitis.461b970e.wav";